export default "__VITE_ASSET__b108aa46__"